import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
// import Paper from "@material-ui/core/Paper";
// import constants from "../../constants/User/user";
import { useUser } from "../../context/userContext";

// import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/material-dashboard-react/components/dialogHowToUse";
// import connect from "../../assets/img/ConnectState.png";
import "./classes.css";
import { Markup } from "interweave";
import Button from "components/CustomButtons/Button.js";

// import CardAvatar from "components/Card/CardAvatar.js";

// import { TextField } from "@material-ui/core";
// const percent = "100%";
import "./userDialog.css";
const useStyles = makeStyles(styles);

export default function TransformationAlgorithmdialog(props) {
  const {
    isActiveTransformationAlgorithmDialog,
    setActiveTransformationAlgorithmDialog,
  } = useUser();

  //   const [spacing] = React.useState(2);
  const classes = useStyles();

  const handleClose = () => {
    setActiveTransformationAlgorithmDialog(false);
  };

  return (
    <div>
      <Dialog
        open={isActiveTransformationAlgorithmDialog}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className={classes.dialog} id="alert-dialog-slide-title">
          <div className="wrapper-title">
            {props.title}
            <div className="wrapper-button-close">
              <Button onClick={handleClose}>X</Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <Markup
            className="table"
            containerTagName="div"
            allowAttributes={true}
            allowElements={true}
            content={props.content}
          />
        </DialogContent>
        <DialogActions className={classes.dialog}></DialogActions>
      </Dialog>
    </div>
  );
}
